import { bookingStatus } from 'types/booking';
import serviceTypeCodes from 'constants/serviceTypeCodes';

export const passengersDetails = ({ passengers = [] }) =>
  passengers.map((p) => ({
    passengerId: p?.id,
    firstName: p?.firstName,
    lastName: p?.lastName
  }));

export const getMultiInventoryLegs = ({ legs = [] }) =>
  legs.filter(
    ({ isMultiInventory = false, serviceType = {} }) =>
      isMultiInventory &&
      serviceType?.code !== serviceTypeCodes.EUROSTAR &&
      serviceType?.code !== serviceTypeCodes.GREENSPEED &&
      serviceType?.code !== serviceTypeCodes.SNCB &&
      serviceType?.code !== serviceTypeCodes.NS
  );

export const shouldCheckStatusesBetweenS3AndPAO = ({ status = '', outbound = [], inbound = [] }) =>
  status === bookingStatus.CONFIRMED &&
  (!!getMultiInventoryLegs({ legs: outbound })?.length || !!getMultiInventoryLegs({ legs: inbound })?.length);

export const mapData = ({ products = [] }) =>
  products.map(({ cancelled = false, externalTicketNumber = null, passenger = {} }) => ({
    s3Status: cancelled ? bookingStatus.CANCELLED : bookingStatus.CONFIRMED,
    paoStatus: externalTicketNumber && !cancelled ? bookingStatus.CONFIRMED : bookingStatus.CANCELLED,
    firstName: passenger?.firstName,
    lastName: passenger?.lastName
  }));

export const reducedMultiInventoryLegs = ({ allMultiInventoryLegs = [], paxs = [] }) => {
  if (paxs.length > 0) {
    return allMultiInventoryLegs.map(({ id = '', origin = {}, destination = {}, timing = {}, serviceType = {}, products = [] }) => ({
      segmentId: id,
      originName: origin?.name,
      destinationName: destination?.name,
      departureDate: timing?.date,
      serviceType: {
        brandCode: serviceType?.brandCode
      },
      paoAndS3: mapData({ products })
    }));
  }

  return [];
};

export const filterMultiInventoryLegsByDiscrepencies = ({ multiInventoryLegs = [] }) =>
  multiInventoryLegs.map(({ paoAndS3 = [], ...rest }) => ({
    ...rest,
    mismatchBetweenPaoAndS3: paoAndS3.filter(({ paoStatus = '', s3Status = '' }) => !!paoStatus && !!s3Status && paoStatus !== s3Status)
  }));

export const getDiscrepencies = (booking) => {
  const getPassengers = passengersDetails({ passengers: booking.passengers });
  const outboundMultiInventory = getMultiInventoryLegs({ legs: booking?.outbound });
  const inboundMultiInventory = getMultiInventoryLegs({ legs: booking?.inbound });
  const allMultiInventoryLegs = [...outboundMultiInventory, ...inboundMultiInventory];
  const multiInventoryLegs = reducedMultiInventoryLegs({ allMultiInventoryLegs, paxs: getPassengers });
  const filteredData = filterMultiInventoryLegsByDiscrepencies({ multiInventoryLegs });

  return filteredData.filter((ad) => !!ad?.mismatchBetweenPaoAndS3?.length);
};
